export function productIsDeleted(product) {
  return product.deletedAt !== null;
}

export function productBlockedApproved(product) {
  return product.approvalState === "blocked_approved";
}

export function productApprovalRequested(product) {
  return product.approvalState === "approval_requested";
}

export function productIsInProcess(product) {
  return product.approvalState !== "approved";
}

// internal helper for the following to methods
// For use in components, product.isLive might be better to use instead of
// using this method
function productIsPublished(product) {
  return product.publishOn !== null;
}

export function publishingIsInProcess(product) {
  return (
    (productIsPublished(product) && productApprovalRequested(product)) ||
    (!productIsPublished(product) && product.approvalState === "approved")
  );
}
